import { Checkpoint, Config } from '@langchain/langgraph-sdk';

import * as React from 'react';
import useSWRMutation from 'swr/mutation';

import { useLangGraphClient } from '../api';
import { useGraphThreadHistoryMutate } from '../api/useGraphSwr';
import { ContinueRefContext } from '../components/debug/trace/GraphInputEditor.utils';
import { StateContext } from '../control/state';

export const useReRunNode = ({
  onSuccess,
  updateTarget,
}: {
  onSuccess?: () => void;
  updateTarget: string | Checkpoint | null;
}) => {
  const continueRef = React.useContext(ContinueRefContext);
  const [langgraph, apiUrl] = useLangGraphClient();
  const state = React.useContext(StateContext);
  const historySWRMutate = useGraphThreadHistoryMutate(state.threadId);
  return useSWRMutation(
    [apiUrl, 'threads', state.threadId],
    async (_, { arg: { config } }: { arg: { config: Config | undefined } }) => {
      if (state.threadId == null) return;
      if (!updateTarget) return;

      const data: Pick<Config, 'configurable'> & { checkpoint?: Checkpoint } =
        await langgraph.threads.updateState(
          state.threadId,
          typeof updateTarget === 'string'
            ? { values: null, asNode: '__copy__', checkpointId: updateTarget }
            : { values: null, asNode: '__copy__', checkpoint: updateTarget }
        );

      // TODO: append the new state to updates
      // as we should know all the information upfront
      await historySWRMutate();

      const checkpoint =
        data.checkpoint ??
        data.configurable?.checkpoint_id ??
        (data.configurable?.thread_ts as string | undefined);

      if (checkpoint) {
        continueRef.current?.({ checkpoint, config });
        onSuccess?.();
      }
    }
  );
};
